/**
 * Http client for APICloud
 * collection of utils
 * @author Creaman Xu
 * @copyright Copyright (c) 2018 apicloud.com
 */

(function (window) {
  "use strict";

  var u = {};

  u.isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };

  u.uid = function (len) {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var nchars = chars.length;
    var output = '';

    while (len--) {
      output += chars[Math.random() * nchars | 0];
    }

    return output;
  };

  u.assign = function (target /* Variable Arguments */ ) {
    if (target === null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var i = 1; i < arguments.length; ++i) {
      var from = arguments[i];

      if (from !== null) { // Skip over if undefined or null
        for (var key in from) {
          if (Object.prototype.hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
      }
    }

    return to;
  };

  u.cacheImage = function (cls, rattr) {
    var imgs = $api.domAll(cls);

    for (var i = 0; i < imgs.length; i++) {
      (function (el) {
        var url = $api.attr(el, rattr);
        url && api.imageCache({
          url: url,
          thumbnail: false
        }, function (ret, err) {
          $api.attr(el, 'src', ret && ret.url || url);
          $api.removeAttr(el, rattr);
        });
      })(imgs[i]);
    }
  };

  window.ClientUtils = u;
})(window);



// WEBPACK FOOTER //
// ./src/utils/utils.js